"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.materializeReceivableResponseTapePreviewChangeset = exports.createReceivableResponseTapePreviewArtifact = void 0;
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const createReceivableResponseTapePreviewArtifact = ({ artifactDocumentId, loanProductSlugs, }) => {
    return {
        id: (0, uuid_1.v4)(),
        type: 'receivableResponseTapePreview',
        configuration: {}, // no configuration needed
        loanProductSlug: null,
        creditFacilitySlug: null,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: `receivableResponseTapePreview_${loanProductSlugs.join('|')}`,
    };
};
exports.createReceivableResponseTapePreviewArtifact = createReceivableResponseTapePreviewArtifact;
/**
 * Helper used by the assignedLoanTape step (masterLoanTape archetype only). Creates a
 * single shared receivableResponseTapePreview node and links one masterLoanTape per
 * loan product into it. Not an ISynthetic itself — it has no independent detach; the
 * preview is removed by the assignedLoanTape step's fromDb.
 *
 * +----------------+
 * | masterLoanTape | --+
 * +----------------+   |
 *                      |     +-------------------------------+
 *          ...         +---> | receivableResponseTapePreview |
 *                      |     +-------------------------------+
 * +----------------+   |
 * | masterLoanTape | --+
 * +----------------+
 */
const materializeReceivableResponseTapePreviewChangeset = ({ loanProductSlugs, masterLoanTapes, }) => {
    const artifactDocumentId = utils.parseArtifactDocumentId(masterLoanTapes);
    const receivableResponseTapePreview = (0, exports.createReceivableResponseTapePreviewArtifact)({ artifactDocumentId, loanProductSlugs });
    const receivableResponseTapePreviewDependencies = [];
    (0, remeda_1.forEach)(loanProductSlugs, (loanProductSlug) => {
        const filterMasterLoanTapes = (0, remeda_1.filter)(masterLoanTapes, (mlt) => mlt.loanProductSlug === loanProductSlug);
        (0, common_1.finleyAssert)(filterMasterLoanTapes.length === 1, `unable to find single master loan tape by ${loanProductSlug} for masterLoanTape type`);
        const masterLoanTape = filterMasterLoanTapes[0];
        receivableResponseTapePreviewDependencies.push({
            outputArtifactId: receivableResponseTapePreview.id,
            inputArtifactId: masterLoanTape.id,
        });
    });
    return {
        receivableResponseTapePreview,
        receivableResponseTapePreviewDependencies,
    };
};
exports.materializeReceivableResponseTapePreviewChangeset = materializeReceivableResponseTapePreviewChangeset;
//# sourceMappingURL=receivableResponseTapePreview.js.map